/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { language } from "../../language/Language";

function ProductsFilter({ products, onFilterChange }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [priceRange, setPriceRange] = useState([0, 6000]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [sortOption, setSortOption] = useState("default");
  const [maxPrice, setMaxPrice] = useState(6000);

  // Extract all categories from products
  const categories = products
    ? products
        .filter((product) => product.cat_id && product.cat_name) // تأكد من وجود cat_id و cat_name
        .reduce((unique, product) => {
          const existing = unique.find((item) => item.value === product.cat_id);
          if (!existing) {
            unique.push({
              label: product.cat_name,
              value: product.cat_id,
              desc: product.cat_desc,
            });
          }
          return unique;
        }, [])
    : [];

  // في useEffect الخاص بحساب أعلى سعر، قم بالتعديل كالتالي:
  useEffect(() => {
    if (products?.length > 0) {
      const availableProducts = products.filter(
        (product) => parseFloat(product.stock) > 0
      );
      if (availableProducts.length > 0) {
        const highestPrice = Math.max(...availableProducts.map((p) => p.price));
        setMaxPrice(Math.ceil(highestPrice / 500) * 500); // Round up to nearest 500
        setPriceRange([0, highestPrice]);
      }
    }
  }, [products]);

  const handleSearch = (value) => {
    setSearchQuery(value);
    applyFilters({ searchQuery: value });
  };

  const handlePriceChange = (value) => {
    setPriceRange(value);
    applyFilters({ priceRange: value });
  };

  const handleCategoryChange = (checkedValues) => {
    setSelectedCategories(checkedValues);
    applyFilters({ selectedCategories: checkedValues });
  };

  const handleSortChange = (value) => {
    setSortOption(value);
    applyFilters({ sortOption: value });
  };

  const resetFilters = () => {
    setSearchQuery("");
    setPriceRange([0, maxPrice]);
    setSelectedCategories([]);
    setSortOption("default");

    // Reset filters in parent component
    onFilterChange({
      searchQuery: "",
      priceRange: [0, maxPrice],
      selectedCategories: [],
      sortOption: "default",
    });
  };

  const applyFilters = (updatedFilters) => {
    onFilterChange({
      searchQuery:
        updatedFilters.searchQuery !== undefined
          ? updatedFilters.searchQuery
          : searchQuery,
      priceRange:
        updatedFilters.priceRange !== undefined
          ? updatedFilters.priceRange
          : priceRange,
      selectedCategories:
        updatedFilters.selectedCategories !== undefined
          ? updatedFilters.selectedCategories
          : selectedCategories,
      sortOption:
        updatedFilters.sortOption !== undefined
          ? updatedFilters.sortOption
          : sortOption,
    });
  };

  const isArabic = language === "ar";
  const textAlign = isArabic ? "right" : "left";
  const direction = isArabic ? "rtl" : "ltr";

  return (
    <div
      className="rounded-lg shadow-md mb-5 static top-32"
      style={{ direction }}
    >
      {/* <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold">
          {isArabic ? "تصفية المنتجات" : "Filter Products"}
        </h3>
        <Button icon={<ClearOutlined />} onClick={resetFilters} size="small">
          {isArabic ? "إعادة تعيين" : "Reset"}
        </Button>
      </div> */}

      {/* Search */}
      <div className="">
        {/* <h4 className="font-medium mb-2" style={{ textAlign }}>
          {isArabic ? "بحث" : "Search"}
        </h4> */}
        <Input
          placeholder={isArabic ? "ابحث عن منتجات..." : "Search products..."}
          prefix={<SearchOutlined />}
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
          className="w-full h-[45px]"
        />
      </div>

      {/* <Divider className="my-4" /> */}

      {/* Price Range */}
      {/* <div className="mb-6">
        <h4 className="font-medium mb-2" style={{ textAlign }}>
          {isArabic ? "نطاق السعر" : "Price Range"}
        </h4>
        <Slider
          range
          min={0}
          max={maxPrice}
          value={priceRange}
          onChange={handlePriceChange}
          className="mb-2"
        />
        <div className="flex justify-between text-sm text-gray-600">
          <span>{priceRange[0]}</span>
          <span>{priceRange[1]}</span>
        </div>
      </div> */}

      {/* <Divider className="my-4" /> */}

      {/* Categories */}
      {/* {categories.length > 0 && (
        <div className="mb-6">
          <h4 className="font-medium mb-2" style={{ textAlign }}>
            {isArabic ? "الفئات" : "Categories"}
          </h4>
          <Checkbox.Group
            options={categories}
            value={selectedCategories}
            onChange={handleCategoryChange}
            className="flex flex-col gap-2"
          />
        </div>
      )} */}

      {/* <Divider className="my-4" /> */}

      {/* Special Filter (based on the 'special' field) */}
      {/* <div className="mb-6">
        <h4 className="font-medium mb-2" style={{ textAlign }}>
          {isArabic ? "عروض خاصة" : "Special Offers"}
        </h4>
        <Checkbox className="block mb-2">
          {isArabic ? "عروض خاصة فقط" : "Special offers only"}
        </Checkbox>
      </div> */}

      {/* <Divider className="my-4" /> */}

      {/* Sort Options */}
      {/* <div className="mb-6">
        <h4 className="font-medium mb-2" style={{ textAlign }}>
          {isArabic ? "ترتيب حسب" : "Sort By"}
        </h4>
        <Select
          className="w-full"
          value={sortOption}
          onChange={handleSortChange}
          options={[
            { value: "default", label: isArabic ? "الافتراضي" : "Default" },
            {
              value: "price_asc",
              label: isArabic
                ? "السعر: من الأقل إلى الأعلى"
                : "Price: Low to High",
            },
            {
              value: "price_desc",
              label: isArabic
                ? "السعر: من الأعلى إلى الأقل"
                : "Price: High to Low",
            },
            {
              value: "discount_asc",
              label: isArabic
                ? "الخصم: من الأقل إلى الأعلى"
                : "Discount: Low to High",
            },
            {
              value: "discount_desc",
              label: isArabic
                ? "الخصم: من الأعلى إلى الأقل"
                : "Discount: High to Low",
            },
            { value: "name_asc", label: isArabic ? "الاسم: أ-ي" : "Name: A-Z" },
            {
              value: "name_desc",
              label: isArabic ? "الاسم: ي-أ" : "Name: Z-A",
            },
          ]}
        />
      </div> */}

      {/* <Button
        type="primary"
        className="w-full bg-mainColor"
        icon={<FilterOutlined />}
        onClick={() => applyFilters({})}
      >
        {isArabic ? "تطبيق الفلتر" : "Apply Filter"}
      </Button> */}
    </div>
  );
}

export default ProductsFilter;
